// Environment configuration
export const config = {
  // Relative, and that is the whole design.
  //
  // The edge serves the API under /api on whatever hostname the app was loaded from, so this
  // one string is correct for every clinic: on motioncare.ro it resolves to
  // https://motioncare.ro/api, on carefull.ro to https://carefull.ro/api. That is what keeps
  // ONE static build serving every tenant -- an absolute API host would have to differ per
  // clinic and would force a build each.
  //
  // It also means nothing is cross-origin in production, so there is no per-clinic CORS
  // allow-list to keep in step with the tenant_domains table.
  //
  // NOTE the argument above is against a per-clinic API host (api.motioncare.ro), not against
  // a single shared one (api.carefull.ro) -- a shared absolute host would also fit in one
  // build. The reason it is not used is different and more basic: the backend resolves the
  // tenant from the hostname the request arrived at. Called at api.carefull.ro, that hostname
  // names no clinic, so the public front door would answer "platform" on every clinic's
  // domain and the signed-out branding would not work at all. See TenantHostFilter.
  //
  // The backend still serves its endpoints at the ROOT; /api is the edge's prefix and is
  // stripped before the request reaches it. Locally, src/setupProxy.js does the same job.
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL ?? '/api',
  environment: process.env.REACT_APP_ENV || 'development',
  isDevelopment: process.env.NODE_ENV === 'development',
  isProduction: process.env.NODE_ENV === 'production',
};

export default config;
